(function () {
  const root = document.querySelector('[data-nolyae-bundle]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-nolyae-bundle-json]').textContent);
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const fmt = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency });

  const state = data.slots.map((s) => ({ ...s, resolved: null }));

  function selectedOptions(idx) {
    return Array.from(root.querySelectorAll(`select[data-slot="${idx}"]`))
      .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
      .map((sel) => sel.value);
  }

  function resolve(idx) {
    const slot = state[idx];
    const opts = selectedOptions(idx);
    let v = slot.variants.find((x) => x.options.every((o, i) => o === opts[i]));
    if (!v || !v.available) {
      const avail = slot.variants.find((x) => x.available);
      if (avail) v = avail; // repli 1re variante dispo
    }
    slot.resolved = v || slot.variants[0];
    return slot.resolved;
  }

  function renderRow(idx) {
    const slot = state[idx];
    const v = slot.resolved;
    const priceEl = root.querySelector(`[data-slot-price="${idx}"]`);
    if (slot.free) {
      priceEl.innerHTML = `<span class="nolyae-bundle__price-compare">${fmt(v.compare_at)}</span> <span class="nolyae-bundle__price-free">Offert</span>`;
    } else {
      const cmp = v.compare_at > v.price ? `<span class="nolyae-bundle__price-compare">${fmt(v.compare_at)}</span>` : '';
      priceEl.innerHTML = `${cmp}<span class="nolyae-bundle__price-current">${fmt(v.price)}</span>`;
    }
    const img = root.querySelector(`[data-slot-image="${idx}"] img`);
    if (img && v.image) img.src = v.image;
  }

  function renderSummary() {
    let total = 0, compare = 0;
    state.forEach((slot) => {
      const v = slot.resolved;
      compare += v.compare_at;
      if (!slot.free) total += v.price;
    });
    root.querySelector('[data-bundle-total]').textContent = fmt(total);
    root.querySelector('[data-bundle-compare]').textContent = fmt(compare);
    const savings = compare > 0 ? Math.round(((compare - total) / compare) * 100) : 0;
    const el = root.querySelector('[data-bundle-savings]');
    el.textContent = savings > 0 ? `tu économises -${savings}%` : '';
  }

  function refreshAll() {
    state.forEach((_, idx) => { resolve(idx); renderRow(idx); });
    renderSummary();
  }

  root.querySelectorAll('.nolyae-bundle__select').forEach((sel) => {
    sel.addEventListener('change', () => {
      const idx = Number(sel.dataset.slot);
      resolve(idx); renderRow(idx); renderSummary();
    });
  });

  window.nolyaeBundleGetItems = () =>
    state.map((slot) => ({ id: slot.resolved.id, quantity: 1 }));

  const addBtn = root.querySelector('[data-nolyae-bundle-add]');
  addBtn.addEventListener('click', async () => {
    addBtn.setAttribute('aria-busy', 'true');
    const items = window.nolyaeBundleGetItems();
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : [];
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
      });
      const payload = await res.json();
      if (!res.ok) { console.error('bundle add error', payload); addBtn.removeAttribute('aria-busy'); return; }
      if (cartDrawer && payload.sections) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(payload);
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      } else {
        window.location = window.Shopify.routes.root + 'cart';
      }
    } catch (e) {
      console.error(e);
      window.location = window.Shopify.routes.root + 'cart';
    } finally {
      addBtn.removeAttribute('aria-busy');
    }
  });

  refreshAll();
})();
